module.exports = __webpack_public_path__ + "img/mapa.f0596680.png";